
export const multiSelectStatisticDataSettings = [

    { value: "acceptedEvents", label: "Accepted Events", color: "#00B8D9" },
    { value: "acceptedWidthCV", label: "Accepted Width CV%", color: "#5243AA" },
    { value: "amplitudeCV", label: "Amplitude CV %", color: "#5243AA" },
    { value: "amplitudeMean", label: "Amplitude mean", color: "#5243AA" },
    { value: "clusteringDataQuality", label: "Clustering Data Quality", color: "#5243AA" },
    { value: "concentration", label: "Concentration (cp/uL)", color: "#5243AA" },
    { value: "meannegativeamplitude", label: "Mean negative amplitude", color: "#524" },
    { value: "meanpositiveamplitude", label: "Mean positive amplitude", color: "#5243AA" },
    { value: "meanpositive-negativeamplituderatio", label: "Mean positive/negative amplitude ratio", color: "#5243AA" },
    { value: "polydispersity", label: "Polydispersity", color: "#5243AA" },
    { value: "polydispersityRevB", label: "Polydispersity Rev B", color: "#5243AA" },
    { value: "rainmiddle%", label: "Rain, Middle %", color: "#5243AA" },
    { value: "rejectedEvents", label: "% Rejected events", color: "#0052CC" },
    { value: "svalue", label: "S Value", color: "#5243AA" },
    { value: "thresholddataquality", label: "Threshold data quality", color: "#5243AA" },
    { value: "thresholdvalue", label: "Threshold value", color: "#5243AA" },
    { value: "totalevents", label: "Total Events", color: "#5243AA" },
    { value: "widthmean", label: "Width Mean", color: "#5243AA" },
    { value: "widthsigma", label: "Width sigma", color: "#524" },
]
export const statisticDataSettings = [
    { label: "Accepted Events", value: "Accepted Events" },
    { label: "Accepted Width CV%", value: "Accepted Width CV%" },
    { label: "Amplitude CV %", value: "Amplitude CV %" },
    { label: "Amplitude Mean", value: "Amplitude mean" },
    { label: "Clustering Data Quality", value: "Clustering Data Quality" },
    { label: "Concentration (cp/uL)", value: "Concentration (cp/uL)" },
    { label: "Mean Negative Amplitude", value: "Mean negative amplitude" },
    { label: "Mean Positive Amplitude", value: "Mean positive amplitude" },
    { label: "Mean Positive/Negative Amplitude Ratio", value: "Mean positive/negative amplitude ratio" },
    { label: "Polydispersity", value: "Polydispersity" },
    { label: "Polydispersity Rev B", value: "Polydispersity Rev B" },
    { label: "Rain, Middle %", value: "Rain, Middle %" },
    { label: "% Rejected Events", value: "% Rejected events" },
    { label: "S Value", value: "S Value" },
    { label: "Sample Name", value: "sample_name" },
    { label: "Threshold Data Quality", value: "Threshold data quality" },
    { label: "Threshold Value", value: "Threshold value" },
    { label: "Total Events", value: "Total Events" },
    { label: "Width Mean", value: "Width Mean" },
    { label: "Width Sigma", value: "Width sigma" },
];

// export const statisticDataSettings = [
//     "Accepted Events",
//     "% Rejected events",
//     "Accepted Width CV%",
//     "Amplitude CV %",
//     "Amplitude mean",
//     "Concentration (cp/uL)",
//     "Mean negative amplitude",
//     "Mean positive amplitude",
//     "Mean positive/negative amplitude ratio",
//     "Polydispersity",
//     "Polydispersity Rev B",
//     "Rain, Middle %",
//     "S Value",
//     "Threshold data quality",
//     "Total Events",
//     "Width Mean",
//     "Width sigma",
//     "Sample Name"
// ]

